import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import footerLogo from '../assets/images/eori-logo-footer.png';
import packageJson from '../../package.json';
import { StoreContext } from '../components/Store';

const Footer = () => {
  const location = useLocation();

  const store = useContext(StoreContext);
  const siteConfig = store.wlpConfig[0];

  return (
    <div className="footer-container-wrapper">
      <div class="footer-container">
        {location.pathname === '/' && siteConfig.wlpName === '360PAY' && (
          <>
            <p>
              <strong>EORI (UK)</strong> is a 360 Pay Company leading provider of customs and trade compliance
              solutions. Delivering fast, accurate, and secure customs clearance and guidance, helping companies meet UK
              and EU customs requirements with confidence through our commitment to efficiency, transparency, and expert
              support. At EORI (UK), we’ve spent years helping businesses navigate these challenges, and we’ve built our
              expertise into <strong>CABIE</strong> (Customs and Borders Import Export), our customs platform that
              removes the uncertainty from international trade.
            </p>

            <p style={{ textAlign: 'center' }}>
              <strong>Deep trade expertise:</strong> Our team understands the real-world challenges of customs
              compliance
              <br />
              <strong>Proven track record:</strong> We’ve guided hundreds of importers and exporters through complex
              border requirements
              <br />
              <strong>Technology-backed solutions:</strong> CABIE combines our industry knowledge with powerful
              automation and white label option
            </p>
            <p style={{ textAlign: 'center' }}>
              Learn more at{' '}
              <a href="https://www.eori.uk" target="_blank" rel="noopener noreferrer">
                www.eori.uk
              </a>
            </p>
          </>
        )}

        <div className="footer-wrapper">
          <img alt="logo" src={footerLogo} className="logo-image" />
          <a
            href="https://www.eori.uk/privacy-policy"
            className="first-child"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Notice
          </a>
          <a href="/">CABIE ENS Release: {packageJson.version}</a>
          <a
            href="https://www.eoricustomtech.com/assets/terms-and-conditions.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms and Conditions
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
